import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'

type Props = {
  url: string
  title: string
  image: string
  index: number
  homeType?: 'nam' | 'nu' | 'chung'
}

export const CategoryCard: React.FC<Props> = ({
  url,
  title,
  image,
  index,
  homeType,
}) => {
  // Format tracking value based on homeType
  const trackingValue =
    homeType === 'nam'
      ? `home-nam__category-card__vitri-${index}`
      : homeType === 'nu'
        ? `home-nu__category-card__vitri-${index}`
        : `home__category-card__vitri-${index}`

  return (
    <figure className='block h-full'>
      <Link
        href={url}
        className='group flex h-full flex-col items-center justify-center space-y-2'
        ga-tracking-value={trackingValue}
        ga-tracking-label={title}
      >
        <picture className='block h-full w-full overflow-hidden rounded-2xl'>
          <source
            media='(max-width: 768px)'
            srcSet={ImageHelper.getImageUrl(image, '270_306')}
          />
          <Image
            src={
              ImageHelper.getImageUrl(image, 'm') || '/images/logo-mobile.svg'
            }
            alt={title}
            width={280}
            height={380}
            sizes='(max-width: 768px) 100vw, 280px'
            className='object-cover object-bottom transition-transform duration-500 group-hover:scale-105 2xl:h-full 2xl:w-full'
            loading='lazy'
          />
        </picture>
        <p className='text-body-2 text-clip whitespace-nowrap font-criteria uppercase transition-colors duration-300 group-hover:text-primary'>
          {title}
        </p>
      </Link>
    </figure>
  )
}
